import type { WeddingData } from '@/mock/types'

export function receptionGuests(data: WeddingData) {
  const guests = data.parties
    .flatMap((party) => party.persons)
    .filter((person) => person.attendance !== 'declined')
  const confirmed = guests.filter((person) => person.attendance === 'confirmed')
  return {
    total: guests.length,
    adults: confirmed.filter((person) => !person.child).length,
    children: confirmed.filter((person) => person.child).length,
    pending: guests.length - confirmed.length,
    diets: [
      {
        label: 'Vegetariánské',
        count: guests.filter((p) => p.diets.includes('vegetarian')).length,
      },
      { label: 'Veganské', count: guests.filter((p) => p.diets.includes('vegan')).length },
      { label: 'Bez lepku', count: guests.filter((p) => p.diets.includes('gluten-free')).length },
      {
        label: 'Bez laktózy',
        count: guests.filter((p) => p.diets.includes('lactose-free')).length,
      },
    ].filter((diet) => diet.count > 0),
    withDiet: guests.filter((person) => person.diets.length > 0).length,
  }
}
